import React, { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Grid, CircularProgress } from '@material-ui/core';
import clsx from 'clsx';
import { getAgentFeaturePermissions, Agent } from '@moderepo/mode-internal-apis';
import { fetchProjectDeviceById, ritzDataContext, selectLoggedInAgent, selectProjectAgent, selectProjectById, selectProjectDeviceById }
    from '@moderepo/mode-data-state-ritz';
import { useRitzTranslation } from '../../utils/customHooks';
import { DeviceBasicInfoContainer } from './DeviceBasicInfoContainer';
import { DeviceDevInfoContainer } from './DeviceDevInfoContainer';
import { DeviceKVPairsListingContainer } from './DeviceKVPairsListingContainer';
import { DeviceConfigSchemasListingContainer } from './DeviceConfigSchemasListingContainer';


export const DeviceSettingsPage: React.FC = () => {
    // Get the params from the route or url
    const params = useParams();
    const projectId = Number(params.projectId);
    const userId = params.userId ? Number(params.userId) : undefined;  // OPTIONAL - depending on how the agent got to this
    const homeId = params.homeId ? Number(params.homeId) : undefined;  // OPTIONAL - depending on how the agent got to this page
    const deviceId = Number(params.deviceId);

    const { state:dataState, dispatch:dataDispatch } = useContext(ritzDataContext);
    const loggedInAgent = selectLoggedInAgent(dataState) as Agent;
    const project = selectProjectById(dataState, projectId);
    const projectAgent = loggedInAgent ? selectProjectAgent(dataState, project?.id, loggedInAgent.id) : undefined;
    const device = selectProjectDeviceById(dataState, deviceId);

    const { trans } = useRitzTranslation(project);
    const permissions = getAgentFeaturePermissions(projectAgent);



    /**
     * This useEffect is used for loading device data on component init
     */
    useEffect(() => {
        dataDispatch(fetchProjectDeviceById(projectId, deviceId)).catch(() => { /* ignore error */ });
    }, [dataDispatch, projectId, deviceId]);



    return (
        <div className={clsx('page-main-content')}>
            <div className="title-bar">
                <div className="title-bar-item title-text">
                    <div className="page-title">
                        {trans('page.title.project_device_settings')}
                    </div>
                    <div className="page-subtitle">
                        {trans('page.subtitle.project_device_settings')}
                    </div>
                </div>
            </div>


            {project && device && (
                <div>
                    <Grid container spacing={3}>

                        {permissions.canViewProjectDeviceDetails && (
                            <Grid item xs={12} lg={6}>
                                <DeviceBasicInfoContainer
                                    className={clsx('match-height')}
                                    projectId={projectId}
                                    deviceId={deviceId}
                                    userId={userId}
                                    homeId={homeId}
                                />
                            </Grid>
                        )}

                        {permissions.canViewProjectDeviceDetails && (
                            <Grid item xs={12} lg={6}>
                                <DeviceDevInfoContainer
                                    className={clsx('match-height')}
                                    projectId={projectId}
                                    deviceId={deviceId}
                                    userId={userId}
                                    homeId={homeId}
                                />
                            </Grid>
                        )}

                        <Grid item xs={12}>
                            <DeviceConfigSchemasListingContainer
                                className={clsx('match-height')}
                                projectId={projectId}
                                deviceId={deviceId}
                                userId={userId}
                                homeId={homeId}
                            />
                        </Grid>


                        {permissions.canViewDeviceKVPair && (
                            <Grid item xs={12}>
                                <DeviceKVPairsListingContainer
                                    className={clsx('match-height')}
                                    projectId={projectId}
                                    deviceId={deviceId}
                                />
                            </Grid>
                        )}

                    </Grid>
                </div>
            )}

            {(!project || !device) && (
                <CircularProgress />
            )}
        </div>
    );
};
